export interface AccountTheme {
  style: 'default' | 'demokratiuka' | 'palmesus';
  brandBlue?: string;
  brandBeige?: string;
  brandPurpleDark?: string;
}

export function getTheme(themeData: Record<string, string> | null): AccountTheme {
  if (!themeData || !themeData.style) return { style: 'default' };
  return {
    style: themeData.style as AccountTheme['style'],
    brandBlue: themeData.brandBlue,
    brandBeige: themeData.brandBeige,
    brandPurpleDark: themeData.brandPurpleDark,
  };
}
